// Room state queries for interaction window - consistent with other room query hooks

import { useRoomStateSelector } from './useRoomStateSelector';
import { getElementsByType } from '@airhead-games/shared/engine/roomState';

export function useRoomInteractionWindow() {
  // --- Combined window state selector ---
  return useRoomStateSelector((state) => {
    const window = state?.currentInteractionWindow;
    const windowWaitingFor = state?.windowWaitingFor ?? [];

    return {
      // For convenience
      window,
      windowType: window?.elementType,
      windowElements:
        window?.elementType && window?.elementIds && state
          ? getElementsByType(state, window.elementType, window.elementIds)
          : [],
      windowEndTime: window?.endTime ?? 0,
      windowId: window?.windowId,
      windowStatus: window?.windowStatus,
      windowWaitingFor,
    };
  });
}
